const Settings = ({
  width = '24',
  height = '24',
  className = '',
  title = '',
  stroke = '1.5',
  role = ''
}): React.ReactNode => {
  const hidden = title && title.length > 0 ? false : true;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      stroke="#000000"
      aria-hidden={`${hidden}`}
      role={role ? role : hidden ? 'graphics-document' : 'img'}
    >
      {!hidden && <title>{title}</title>}
      <path
        d="M9.1042 3.96154L9.83189 2.08308C9.95462 1.76503 10.1705 1.49146 10.4514 1.29821C10.7322 1.10495 11.0648 1.00101 11.4057 1H12.7934C13.1343 1.00101 13.467 1.10495 13.7478 1.29821C14.0286 1.49146 14.2446 1.76503 14.3673 2.08308L15.095 3.96154L17.5657 5.38308L19.5627 5.07846C19.8952 5.03333 20.2336 5.08806 20.5349 5.23572C20.8363 5.38337 21.0869 5.61727 21.255 5.90769L21.9319 7.09231C22.1054 7.38736 22.1853 7.72807 22.1611 8.06948C22.1369 8.41089 22.0098 8.73694 21.7965 9.00462L20.5611 10.5785V13.4215L21.8304 14.9954C22.0437 15.2631 22.1708 15.5891 22.1949 15.9305C22.2191 16.2719 22.1392 16.6126 21.9657 16.9077L21.2888 18.0923C21.1207 18.3827 20.8701 18.6166 20.5688 18.7643C20.2674 18.9119 19.929 18.9667 19.5965 18.9215L17.5996 18.6169L15.1288 20.0385L14.4011 21.9169C14.2784 22.235 14.0625 22.5085 13.7817 22.7018C13.5008 22.8951 13.1682 22.999 12.8273 23H11.4057C11.0648 22.999 10.7322 22.8951 10.4514 22.7018C10.1705 22.5085 9.95462 22.235 9.83189 21.9169L9.1042 20.0385L6.63343 18.6169L4.63651 18.9215C4.304 18.9667 3.96558 18.9119 3.66425 18.7643C3.36292 18.6166 3.11229 18.3827 2.9442 18.0923L2.26728 16.9077C2.09382 16.6126 2.0139 16.2719 2.03807 15.9305C2.06224 15.5891 2.18937 15.2631 2.40266 14.9954L3.63805 13.4215V10.5785L2.36882 9.00462C2.15552 8.73694 2.0284 8.41089 2.00423 8.06948C1.98006 7.72807 2.05997 7.38736 2.23343 7.09231L2.91036 5.90769C3.07844 5.61727 3.32907 5.38337 3.6304 5.23572C3.93173 5.08806 4.27015 5.03333 4.60266 5.07846L6.59959 5.38308L9.1042 3.96154ZM8.71497 12C8.71497 12.6694 8.91348 13.3238 9.28538 13.8804C9.65729 14.437 10.1859 14.8708 10.8044 15.127C11.4228 15.3832 12.1033 15.4502 12.7599 15.3196C13.4164 15.189 14.0195 14.8666 14.4929 14.3933C14.9662 13.9199 15.2886 13.3169 15.4192 12.6603C15.5498 12.0038 15.4827 11.3232 15.2266 10.7048C14.9704 10.0863 14.5366 9.5577 13.98 9.1858C13.4234 8.81389 12.769 8.61538 12.0996 8.61538C11.2019 8.61538 10.341 8.97198 9.7063 9.60672C9.07156 10.2415 8.71497 11.1023 8.71497 12V12Z"
        strokeWidth={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="currentColor"
      />
    </svg>
  );
};

export default Settings;
